var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrapper"},[_c('div',{staticClass:"page-content"},[_c('history-tickets',{attrs:{"h5carUrl":this.h5carUrl}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }